module.exports = require("skypager-documents");


//////////////////
// WEBPACK FOOTER
// external "skypager-documents"
// module id = 44
// module chunks = 0